





















import { Component, Vue, Prop } from 'vue-property-decorator'
import {namespace} from 'vuex-class';
import BtnDefault from '@/components/UI/BtnDefault.vue';
import IClose from '@/components/icons/IClose.vue'

const dialog = namespace('dialog')
const workspace = namespace('workspace')

@Component({
  name: 'top-alert',
  components: {
    BtnDefault,
    IClose,
  }
})
export default class TopAlert extends Vue {
  @dialog.Mutation('SetFullPlanShow') protected SetFullPlanShow: any
  @dialog.Mutation('setSupportDialog') protected setSupportDialog: any
  @dialog.Mutation('setSupportDialogOption') protected setSupportDialogOption: any
  @dialog.Mutation('SetTopAlert') protected SetTopAlert: any
  

  @Prop({type: Boolean, default: false}) protected isFree!: boolean

  click() {
    if(this.isFree) {
      this.showPlans()
    } else {
      this.showSupport()
    }
  }

  showPlans() {
    this.SetFullPlanShow(true)
  }

  showSupport() {
    this.setSupportDialogOption('change_plan')
    this.setSupportDialog(true)
  }

  close() {
    this.SetTopAlert(false)
  }

}
